export default "/images/6e7370b5df5957a8d3139644ebfd1fd0.avif";